import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import AlertMessage from '~/components/data-display/AlertMessage';
import { HStack } from '~/components/layout/Stack';
import { useAnalytics } from '~/hooks/useAnalytics';
import { AnalyticsEvents } from '~/services/analytics';
import { useNavigateToCustomerPortal } from '~/services/subscription';
import styles from './PastDueAlert.module.scss';

const PastDueAlert: React.FC = () => {
  const { track } = useAnalytics();
  const { t } = useTranslation('subscriptions');
  const navigateToCustomerPortal = useNavigateToCustomerPortal();
  const [isLoading, setIsLoading] = useState(false);

  const handleOnClick = () => {
    setIsLoading(true);
    track(AnalyticsEvents.SUBSCRIPTION_MAKE_PAYMENT_BUTTON_CLICKED, { context: 'past_due_alert' });
    navigateToCustomerPortal();
  };

  return (
    <div className={styles.container}>
      <AlertMessage box type="warning">
        <HStack gap={2} justify="space-between" align="center" className={styles.alertContent}>
          <span>{t('past_due_alert.message')}</span>
          <Button onClick={handleOnClick} className={styles.button} loading={isLoading}>
            {t('past_due_alert.button')}
          </Button>
        </HStack>
      </AlertMessage>
    </div>
  );
};

export default PastDueAlert;
